import React, { useEffect, useState } from 'react';
import css from './AddNewCourse.module.css';

import * as courseServices from '../../../../../services/courseServices';
import * as programServices from '../../../../../services/programServices';

import toShort from '../../../../../services/utils/dateParser';
import FormData from '../../../_common/elements/forms/FormData';
import FormComment from '../../../_common/elements/forms/FormComent';
import FormButtons from '../../../_common/elements/forms/FormButtons';
import AddEditForm from '../../../_common/elements/forms/AddEditForm';

function AddNewCourse({ data, onAdd, toggleModal, func }) {
    const [message, setMessage] = useState({ message: '', color: 'black' }); //check why colors are not changing
    const [programList, setProgramList] = useState([]);

    let template = {
        _id: data?.courseId || '',
        courseNo: data?.courseNo || '',
        programId: data?.programId || '',
        courseTitle: data?.courseTitle || '',
        courseTypeId: data?.courseTypeId || '',
        // courseStart: data.courseStart ? data.courseStart.slice(0, 10) : '',
        courseStart: data.courseStart ? toShort(data.courseStart, 1) : '',
        // courseEnd: data.courseEnd ? data.courseEnd.slice(0, 10) : '',
        courseEnd: data.courseEnd ? toShort(data.courseEnd, 1) : '',
        courseLocation: data?.courseLocation || '',
        courseDuration: data?.courseDuration || 0,
        courseStatusName: data?.courseStatusName || 'Acquisition',
        courseComments: data.courseComments || '',
    };

    // console.log(data);
    const [newData, setNewData] = useState(template);
    console.log(newData);

    useEffect(() => {
        programServices
            .getOption('list')
            .then((result) => {
                setProgramList((state) => result.data);
                // if (newData.programId) {
                //     setNewData((state) => ({
                //         ...state,
                //         courseTypeId: result.data.filter((a) => a.programId === newData.programId)[0].courseTypeId,
                //     }));
                // }
                // console.log(programList);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [data, newData.programId]);

    const handleChange = (e) => {
        const { id, value } = e.target;

        setNewData((state) => ({
            ...state,
            [id]: value,
        }));
        if (e.target.id === 'programId') {
            setNewData((state) => ({
                ...state,
                courseTitle: programList.filter((x) => x.programId === Number(e.target.value))[0].programTitle,
                courseTypeId: programList.filter((x) => x.programId === Number(e.target.value))[0].courseTypeId,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (func === 'edit') {
            let updateData = newData;
            // console.log(updateData);
            let type = programList.filter((a) => {
                // console.log(`${+a.programId} === ${newData.programId} => ${a.courseTypeId}`);
                return +a.programId === +newData.programId;
            })[0].courseTypeId;
            // console.log(type);
            updateData.courseTypeId = Number(type);
            courseServices
                .edit(updateData)
                .then((result) => {
                    console.log(result);
                    setMessage((state) => ({ message: result.message, color: 'green' })); //check why colors are not changing
                    onAdd(newData);
                    return true;
                })
                .catch((error) => {
                    console.log(message); //check why colors are not changing
                    console.log(error);
                });
        } else {
            courseServices
                .create(newData)
                .then((result) => {
                    console.log(result);
                    setNewData((prevDate) => template);
                    setMessage((state) => ({ message: result.message, color: 'green' })); //check why colors are not changing
                    onAdd(newData);
                    return true;
                })
                .catch((err) => {
                    // console.log(err);
                    setMessage((state) => ({ message: 'Sorry, something went wrong!', color: 'red' })); //check why colors are not changing
                    console.log(message); //check why colors are not changing
                    return false;
                });
        }
    };

    const onAddStay = (e) => {
        e.preventDefault();

        if (newData.programId) {
            handleSubmit(e);
            setNewData((state) => template);
        } else {
            setMessage((state) => ({ message: 'Please select program', color: 'red' })); //check why colors are not changing
        }
    };

    const onAddClose = (e) => {
        e.preventDefault();

        if (newData.programId) {
            let pass = handleSubmit(e);
            if (pass) {
                toggleModal();
            }
        } else {
            setMessage((state) => ({ message: 'Please select program', color: 'red' })); //check why colors are not changing
        }
    };


    return (
        <AddEditForm>
            <FormData>
                <label className={css.label} htmlFor="courseNo">
                    Course ID:{' '}
                </label>
                {func === 'edit' ? (
                    <input className={css.input} type="text" id="courseNo" value={newData.courseNo} onChange={handleChange} disabled />
                ) : (
                    <input className={css.input} type="text" id="courseNo" value={newData.courseNo} onChange={handleChange} />
                )}

                <label htmlFor="programId">Program: </label>
                <select id="programId" onChange={handleChange} className={css.input} value={newData.programId} required>
                    <option key={'na'} value={0}>
                        Select program ...
                    </option>
                    {programList.map((x) => (
                        <option key={x.programId} value={x.programId}>
                            {x.programTitle}
                        </option>
                    ))}
                </select>

                <label className={css.label} htmlFor="courseTitle">
                    Course Title:{' '}
                </label>
                <input className={css.input} type="text" id="courseTitle" value={newData.courseTitle} onChange={handleChange} />

                <label className={css.label} htmlFor="courseStart">
                    Start:{' '}
                </label>
                <input
                    className={css.input}
                    type="date"
                    id="courseStart"
                    value={newData.courseStart}
                    onChange={handleChange}
                    dataDateFormat="DD MMM YYYY"
                />

                <label className={css.label} htmlFor="courseEnd">
                    End:{' '}
                </label>
                <input className={css.input} type="date" id="courseEnd" value={newData.courseEnd} onChange={handleChange} />
                <label className={css.label} htmlFor="courseDuration">
                    Duration:{' '}
                </label>
                <input className={css.input} type="number" id="courseDuration" value={newData.courseDuration} onChange={handleChange} />
                <label className={css.label} htmlFor="courseLocation">
                    Location:{' '}
                </label>
                <input className={css.input} type="text" id="courseLocation" value={newData.courseLocation} onChange={handleChange} />

                <label htmlFor="courseStatusName">Status: </label>
                <select id="courseStatusName" onChange={handleChange} className={css.input} value={newData.courseStatusName}>
                    <option value="Planned">Planned</option>
                    <option value="In progress">In progress</option>
                    <option value="Closed">Closed</option>
                    <option value="Cancelled">Cancelled</option>
                    <option value="Acquisition">Acquisition</option>
                </select>
            </FormData>

            <FormComment>
                <label htmlFor="courseComments">Comments</label>
                <textarea id="courseComments" className={css.textarea} rows="32" onChange={handleChange}>
                    {newData.courseComments}
                </textarea>
            </FormComment>
            <FormButtons>
                <div className={css.submitButtons}>
                    {func === 'edit' ? (
                        <button type="submit" className={css.orangeButton} onClick={onAddClose}>
                            Edit Course
                        </button>
                    ) : (
                        <>
                            <button type="submit" className={css.greenButton} onClick={onAddStay}>
                                Add Course and stay
                            </button>
                            <button type="submit" className={css.greenButton} onClick={onAddClose}>
                                Add Course and close
                            </button>
                        </>
                    )}
                </div>
                <button onClick={toggleModal} className={css.redButton}>
                    Cancel
                </button>
                {/* Check why colors are not changing */}
                <p className={css[message.color]}>{message.message}</p>
            </FormButtons>
        </AddEditForm>
    );
}

export default AddNewCourse;
